import React from "react";
import {withStyles} from "@mui/styles";
import FilterChip from "views/marketplace/merchandising/filter/filterChip";
import filterMenuStyle from "assets/jss/components/filterMenuStyle";
import {getFilterLabel} from "domain/helpers/filterTranslations";

function SimpleFilterPanel({items, classes, singleRow = false}) {
    return (
        <div className={singleRow ? classes.filtersRow : classes.filters}>
            {items.map((element) => (
                <FilterChip key={element.id} label={getFilterLabel(element)} item={element} />
            ))}
        </div>
    );
}

const StyledSimpleFilterPanel = withStyles(filterMenuStyle)(SimpleFilterPanel);

export function SingleRowFilterPanel(props) {
    return <StyledSimpleFilterPanel {...props} singleRow />;
}

export default StyledSimpleFilterPanel;
